<template>
	<div class="mb-4 rounded shadow-xl p-4 border" @click="download(invoice.id)">
		<div class="flex">
			<div class="flex-1">
				<div class="font-medium">{{invoice.number}}</div>
				<div class="text-gray-400 flex justify-between">
					<span>{{invoice.type}}</span>
					<span class="inline md:hidden mr-2 text-black">{{created_at}}</span>
				</div>
			</div>
			<div class="hidden md:block flex-1">
				{{created_at}}
			</div>
			<div class="flex justify-center flex-col">
				<svg class="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
					<path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd"></path>
				</svg>
			</div>
		</div>
	</div>
</template>

<script>
import {mapActions} from "vuex";

export default {
    name: "InvoiceEntry",
    props: ["invoice"],
    methods: mapActions({"download": "profile/invoices/download"}),
    computed: {
        created_at() {
            return this.invoice.created.split('T')[0];
        }
    }
}
</script>

<style scoped>

</style>